//
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProviderModel from '@/models/Purchase/PchProvider'
import PurchaseOrderStateModel from '@/models/Purchase/PchPurchaseOrderState'

//
export default [
  {
    name: 'invoice_number',
    type: 'text-field',
    props: {
      label: 'N° factura',
    },
  },
  {
    name: 'id',
    type: 'text-field',
    props: {
      label: 'N° orden',
    },
  },
  {
    name: 'pch_provider_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'alias_name',
      itemValue: 'id',
      label: 'Proveedor',
      model: ProviderModel,
      noObject: true,
      paramSearch: 'search',
    },
  },
  {
    name: 'pch_payment_condition_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'type',
      itemValue: 'id',
      label: 'Condición de pago',
      model: PaymentConditionModel,
      noObject: true,
      paramSearch: 'type',
    },
  },
  {
    name: 'pch_purchase_order_state_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'state',
      itemValue: 'id',
      label: 'Estado',
      model: PurchaseOrderStateModel,
      noObject: true,
      paramSearch: 'state',
    },
  },
]